import { render, staticRenderFns } from "./RecentBlogsSection.vue?vue&type=template&id=45dcc92d&scoped=true&"
import script from "./RecentBlogsSection.vue?vue&type=script&lang=js&"
export * from "./RecentBlogsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dcc92d",
  null
  
)

export default component.exports